import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import EsignSetup from "./pages/EsignSetup";
import EsignSetupCopy from "./pages/EsignSetupCopy";
import EsignSetupFillableSample from "./pages/EsignSetupFillableSample";
import EsignReceivingEnd from "./pages/EsignReceivingEnd";
import EsignReceivingEndCopy from "./pages/EsignReceivingEndCopy";
import EsignSetupTest from "./pages/EsignSetupTest";
import EsignSetupView from "./pages/EsignSetupView";
import EsignSetupView2 from "./pages/EsignSetupView2";

import EsignSetupTemplate from "./pages/EsignSetupTemplate";
import EsignSetupTemplateCopy from "./pages/EsignSetupTemplateCopy";
import EsignReceivingEndTemplate from "./pages/EsignReceivingEndTemplate1";
import EsignSetupViewTemplate from "./pages/EsignCompletedViewTemplate";
import EsignSenderSignTemplate from "./pages/EsignSenderSignTemplate";
import EsignSenderSignPublicForm from "./pages/EsignSenderSignPublicForm";
import EsignSetupPublicForm from "./pages/EsignSetupPublicForm";
import EsignSetupPublicFormCopy from "./pages/EsignSetupPublicFormCopy";
import EsignReceivingEndPublicForm from "./pages/EsignReceivingEndPublicForm";
import EsignSetupViewPublicForm from "./pages/EsignCompletedViewPublicForm";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* EsignSetupTest is correct but download is not ok 
      EsignSetup is correct for download but other things remaining  */}
        {/* <Route path="/esign-setup" element={<EsignSetup />} /> */}
        <Route path="/esign-setup" element={<EsignSetupCopy />} />
        <Route
          path="/esign-setup-fillable-sample"
          element={<EsignSetupFillableSample />}
        />
        {/* <Route path="/template-builder" element={<EsignSetupTemplate />} /> */}
        <Route path="/template-builder" element={<EsignSetupTemplateCopy />} />
        {/* <Route path="/e-sign-form-create" element={<EsignSetupPublicForm />} /> */}
        <Route path="/e-sign-form-create" element={<EsignSetupPublicFormCopy />} />
        <Route
          path="/sign-template/:template_id/:id/:signer_id"
          element={<EsignReceivingEndTemplate />}
        />
        <Route
          path="/public-form/esign/:bulk_link_id"
          element={<EsignReceivingEndPublicForm />}
        />

        {/* <Route path="/view" element={<EsignSetupView />} /> */}
        <Route path="/view" element={<EsignSetupView2 />} />

        <Route path="/view_template" element={<EsignSetupViewTemplate />} />
        <Route
          path="/sign-template-sender"
          element={<EsignSenderSignTemplate />}
        />
        <Route
          path="/sign-public-form-sender"
          element={<EsignSenderSignPublicForm />}
        />
        <Route
          path="/public_form_response/:bulk_link_id/:user_id"
          element={<EsignSetupViewPublicForm />}
        />

        <Route path="/esign-setup-test" element={<EsignSetupTest />} />

        {/* <Route path="/waiting_for_others_doc/file" element={<EsignSetup />} /> */}
        {/* Route with kba_required */}
        <Route
          path="/send-doc-to-esign/:emailHashed/:file_id/:senderId/:token/:encryptedFileId/kba_required"
          element={<EsignReceivingEnd />}
        />
        {/* Route without kba_required */}
        <Route
          path="/send-doc-to-esign/:emailHashed/:file_id/:senderId/:token/:encryptedFileId?"
          element={<EsignReceivingEnd />}
        />
        <Route
          path="/send-doc-to-esign-copy/:emailHashed/:file_id/:senderId/:token/:encryptedFileId?"
          element={<EsignReceivingEndCopy />}
        />

        <Route path="/" element={<Navigate to="/esign-setup" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
